import React, { useRef } from 'react';
import Dropdown from 'react-dropdown';
import cn from 'classnames';

import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import DropdownMenuFooter from 'clientCommunications/components/Clients/common/DropdownMenuFooter.component';

import 'react-dropdown/style.css';
import CN from './LastVisitDropDown.module.scss';

const weeks = [' ', '2 ', '4', '5', '6', '7', '8', '10', '12', '14', '16', '18', '20', '24'];
const LastVisitOptions = {
  LAST_7_DAYS: '>7days',
  LAST_YEAR: '<1year',
  NO_VISIT: 'noVisit',
  X_WEEKS: 'xWeeks',
  ONE_YEAR: 'oneYear',
};

const isInteger = (value) => parseInt(value) === value;

const LastVisitDropDown = ({ isLastVisit, selectedLastVisit, onCheckLatVisit, onDoneLastVisit, onClearLastVisitSelection, selectedNoVisit }) => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();
  const mainContainerRef = useRef(null);

  const handleCheckLastVisit = (value) => {
    onCheckLatVisit(value);
    if (mainContainerRef.current) {
      mainContainerRef.current.scrollTo({
        top: mainContainerRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  };

  const xWeeksValue = isInteger(parseFloat(selectedLastVisit)) && selectedLastVisit !== LastVisitOptions.ONE_YEAR ? selectedLastVisit : weeks[0];

  // TODO: Revisit a11y for the JSX code below
  return (
    <div
      className={cn({
        'drop-down dd-last-visit': true,
        hidden: !isLastVisit,
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className="main" ref={mainContainerRef}>
        <span className="span-header">{t('allClients.lastVisitDropdown.title')}</span>
        <div className={CN.container}>
          <div className={CN.itemContainer} onClick={() => handleCheckLastVisit(LastVisitOptions.LAST_7_DAYS)}>
            <div className={CN.itemName}>{t('allClients.lastVisitDropdown.lastWeek')}</div>
            <Icon variant="radio" selected={selectedLastVisit === LastVisitOptions.LAST_7_DAYS} width="md" />
          </div>

          <div className={CN.itemContainer} onClick={() => handleCheckLastVisit(LastVisitOptions.LAST_YEAR)}>
            <div className={CN.itemName}>{t('allClients.lastVisitDropdown.pastYear')}</div>
            <Icon variant="radio" selected={selectedLastVisit === LastVisitOptions.LAST_YEAR} width="md" />
          </div>
          <div className={CN.itemContainer} onClick={() => handleCheckLastVisit(LastVisitOptions.NO_VISIT)}>
            <div className={CN.itemName}>{selectedNoVisit ? t('allClients.lastVisitDropdown.noVisits') : t('allClients.lastVisitDropdown.hasNotVisitedBefore')}</div>
            <Icon variant="radio" selected={selectedLastVisit === LastVisitOptions.NO_VISIT} width="md" />
          </div>

          <div className={CN.itemContainer} onClick={() => handleCheckLastVisit(LastVisitOptions.X_WEEKS)}>
            <div className={CN.itemName}>
              <div className={CN.weeksContainer}>
                <div>{t('allClients.lastVisitDropdown.moreThan')} </div>
                <Dropdown
                  className={CN.weeks}
                  controlClassName="react-dropdown"
                  menuClassName={CN.weekDropdown}
                  options={weeks}
                  onChange={(e) => handleCheckLastVisit(e.value)}
                  value={xWeeksValue}
                  arrowClosed={<span className="arrow-closed" />}
                  arrowOpen={<span className="arrow-open" />}
                />
                <div> {t('allClients.lastVisitDropdown.weeksAgo')}</div>
              </div>
            </div>
            <Icon variant="radio" selected={isInteger(parseFloat(selectedLastVisit)) || selectedLastVisit === LastVisitOptions.X_WEEKS} width="md" />
          </div>

          <div className={CN.itemContainer} onClick={() => handleCheckLastVisit(LastVisitOptions.ONE_YEAR)}>
            <div className={CN.itemName}>{t('allClients.lastVisitDropdown.moreThanYearAgo')}</div>
            <Icon variant="radio" selected={selectedLastVisit === LastVisitOptions.ONE_YEAR} width="md" />
          </div>
        </div>
        <DropdownMenuFooter>
          <Button variant="slim" onClick={onClearLastVisitSelection}>
            {t('common.buttons.clearAllUpp')}
          </Button>
          <Button variant="slim" onClick={onDoneLastVisit}>
            {t('common.buttons.doneUpp')}
          </Button>
        </DropdownMenuFooter>
      </div>
    </div>
  );
};

export default LastVisitDropDown;
